/**
 * @fileoverview Workspace Pre-Appointment Statuses
 *
 * URL: /dashboard/pre-appointment-statuses
 *
 * Firm-defined pipeline stages (kanban columns + pipeline state of every
 * pre-appointment job). Lives under the workspace Pre-Appointment section in
 * the sidebar. Admin/owner can create, edit, recolour, re-type, reorder and
 * remove stages — the last Open / Won / Lost stage is protected.
 *
 * - Convex: preAppointment.statuses.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { PreAppointmentStatusesManager } from "@/components/settings/pre-appointment/PreAppointmentStatusesManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/pre-appointment-statuses",
)({
  component: PreAppointmentStatusesPage,
});

function PreAppointmentStatusesPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <PreAppointmentStatusesManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage pipeline stages.
        </div>
      )}
    </div>
  );
}
